import React from "react";
import { get } from "lodash";

import RaceVideo from "@fdr/video";
import { Modal, breakpoints, useMediaQuery } from "@tvg/design-system";
import { RaceVideoFeedback } from "@tvg/ts-types/Race";

import { VideoReplayDesk } from "./styled-components";
import { ReplayVideoModalProps } from "./types";
import { useGetReplayVideoSrc } from "../../hooks/useGetReplayVideoSrc";

export const ReplayVideoModal = ({
  isOpen,
  onClose,
  currentRace,
  userLoggedIn,
  children
}: ReplayVideoModalProps) => {
  const isDesktop = useMediaQuery(breakpoints.desktop.min.md);
  const videoSource = useGetReplayVideoSrc(currentRace, isOpen && isDesktop);

  return (
    <Modal
      qaLabel="replay-video-modal"
      isOpen={isOpen}
      title={`${get(currentRace, "track.trackCode")} R${get(
        currentRace,
        "raceNumber"
      )} Replay`}
      maxWidth={699}
      type={isDesktop ? "lightbox" : "fullscreen"}
      onClose={onClose}
      p={0}
    >
      <>
        {isDesktop ? (
          <VideoReplayDesk
            id="rcn-player-replay-video-fdtv"
            data-qa-label="rcn-player-replay-video-fdtv"
            title="rcn-player-replay-video-fdtv"
            src={videoSource}
            allowFullScreen={true}
            // "frameBorder| scrolling" This is per video streamer Doc recomendation.
            // "scrolling" is depecrated BUUUUT guess what broswer's doesnt fully support CSS way to do this. Magic!!!
            frameBorder="0"
            scrolling="no"
          />
        ) : (
          <RaceVideo
            isVideoInline={true}
            isFDTV
            isURP
            isSticky
            feedback={RaceVideoFeedback.AVAILABLE_REPLAY}
            currentRace={currentRace}
            trackAbbr={get(currentRace, "track.trackCode")}
            stream={get(currentRace, "video.streams[0]", "")}
            isUserLogged={userLoggedIn}
            isLogged={userLoggedIn}
          />
        )}
        {children}
      </>
    </Modal>
  );
};

export default ReplayVideoModal;
